const Card = ({ image, text, link }) => {
  return (
    <div className="cardContainer" style={{ margin: "10px" }}>
      <img src={image} alt="websites" />
      <div className="text">
        <a href={link}>{text}</a>
      </div>
    </div>
  );
};
export default Card;
